import React from "react";

import classNames from "classnames";
import { UseFormMethods } from "react-hook-form";

type InputTextField = React.ComponentPropsWithoutRef<"input">;
type InputTextAreaField = React.ComponentPropsWithoutRef<"textarea">;
type FormInputProps = {
  name: string;
  formProps: Pick<UseFormMethods, "register" | "trigger" | "errors">;
};
export const TextInput = ({
  formProps: { register, trigger, errors },
  onChange,
  className,
  ...props
}: InputTextField & FormInputProps) => (
  <input
    onChange={(e) => {
      trigger(props.name);
      onChange && onChange(e);
    }}
    className={classNames(
      "bg-white focus:outline-none focus:ring border-2 border-neutral-200 rounded py-8 px-16 block w-full appearance-none leading-normal",
      { "border-red-500": errors[props.name] },
      className,
    )}
    id={props.name}
    {...props}
    ref={register}
  />
);

export const TextAreaInput = ({
  formProps: { register, trigger, errors },
  onChange,
  className,
  ...props
}: InputTextAreaField & FormInputProps) => (
  <textarea
    onChange={(e) => {
      trigger(props.name);
      onChange && onChange(e);
    }}
    className={classNames(
      "bg-white focus:outline-none focus:ring border-2 border-primary-100 rounded py-8 px-16 block w-full appearance-none leading-normal",
      { "border-red-500": errors[props.name] },
      className,
    )}
    {...props}
    ref={register}
  />
);

/*
 * This should only be used as your very last resort.
 *
 * This component lets us keep all the react-hook-form stuff
 * But without the styling to allowing for custom styling when
 * The normal styling is not appropiate and can not be overridden
 *
 */
export const UnstyledTextInput = ({
  formProps: { register, trigger, errors },
  onChange,
  invokedRef,
  className,
  ...props
}: InputTextField &
  FormInputProps & {
    invokedRef?: React.Ref<HTMLInputElement>;
  }) => (
  <input
    onChange={(e) => {
      trigger(props.name);
      onChange && onChange(e);
    }}
    className={className}
    {...props}
    ref={invokedRef || register()}
  />
);
export const UnstyledTextAreaInput = ({
  formProps: { register, trigger, errors },
  onChange,
  className,
  ...props
}: InputTextAreaField & FormInputProps) => (
  <textarea
    onChange={(e) => {
      trigger(props.name);
      onChange && onChange(e);
    }}
    className={classNames(
      "bg-white focus:outline-none focus:ring block w-full appearance-none leading-normal",
      className,
    )}
    {...props}
    ref={register()}
  />
);
